/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UserPermissionsResponse,
} from '../models/index';
import {
    UserPermissionsResponseFromJSON,
    UserPermissionsResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class ConfigApi extends runtime.BaseAPI {

    /**
     * Creates request options for getFeatureToggles without sending the request
     */
    async getFeatureTogglesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/config/featureToggles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * returning all available feature toggles for PCO
     * returning all available feature toggles for PCO
     */
    async getFeatureTogglesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: { [key: string]: boolean; }; }>> {
        const requestOptions = await this.getFeatureTogglesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * returning all available feature toggles for PCO
     * returning all available feature toggles for PCO
     */
    async getFeatureToggles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: { [key: string]: boolean; }; }> {
        const response = await this.getFeatureTogglesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUserPermissions without sending the request
     */
    async getUserPermissionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/config/userPermissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns permissions that do not depend on any specific service agreement or business relation - identical for every resource the current user looks at in this session. 
     * returning the current user\'s session-level, role-resolved permissions
     */
    async getUserPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPermissionsResponse>> {
        const requestOptions = await this.getUserPermissionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionsResponseFromJSON(jsonValue));
    }

    /**
     * Returns permissions that do not depend on any specific service agreement or business relation - identical for every resource the current user looks at in this session. 
     * returning the current user\'s session-level, role-resolved permissions
     */
    async getUserPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPermissionsResponse> {
        const response = await this.getUserPermissionsRaw(initOverrides);
        return await response.value();
    }

}
